import Container from "react-bootstrap/esm/Container";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import {useState, useEffect} from "react"
import axios from "axios"

import iaq_logo from "../images/IAQ-logo.PNG"

export default function Rewards() {
  const [defaultplan, setDefaultplan] = useState("");
  const [bondplan, setBondplan] = useState("");
  const [starterplan, setStarterplan] = useState("");
  const [premiumplan, setPremiumplan] = useState("");

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const response = await axios.get('/api/users/planstats');
    setDefaultplan(response.data.defaultplan);
    setBondplan(response.data.bondplan);
    setStarterplan(response.data.starterplan);
    setPremiumplan(response.data.premiumplan);
  };

  return (
    <Container>
      <h1 id="config_header">Rewards</h1>
      <div className="bottom-line"></div>
      <CardGroup>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-clock-fill h3"></i></Card.Title>
            <Card.Text id="card-header">ON THE CLOCK</Card.Text>
            <Card.Text id="card-text">Every hour the air quality data is uploaded and your balance increases according to your plan</Card.Text>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-calendar-check-fill h3"></i></Card.Title>
            <Card.Text id="card-header">PAYOUTS SCHEDULE</Card.Text>
            <Card.Text id="card-text">Daily</Card.Text>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-arrow-left-right h3"></i></Card.Title>
            <Card.Text id="card-header">swap</Card.Text>
            <Card.Text id="card-text">You can exchange tokens on </Card.Text>
            <Card.Link href="https://app.tinyman.org/#/swap?asset_in=0&asset_out=923640017" target="_blank">Tinyman</Card.Link>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-arrow-left-right h3"></i></Card.Title>
            <Card.Text id="card-header">Daily payout requirement</Card.Text>
            <Card.Text id="card-text">250 IAQ or 5 LP tokens</Card.Text>
            <Card.Text id="card-text">In wallet or staked on Cometa</Card.Text>
          </Card.Body>
        </Card>
      </CardGroup>
      <br/>
      <hr/>
      <br/>
      <h2 id="config_header">Available plans</h2>
      <p id="reward_lead">If you have both Bond and Starter plans you will receive a bonus (0.10) and earn 0.40 in total per hour (Bundle)</p>
      <p id="reward_lead">If you are Premium and in addition have both Bond and Starter plans you will receive a bonus (0.30) and earn 0.65 in total per hour (Supreme)</p>
      <div className="bottom-line"></div>
      <CardGroup>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-bandaid-fill h3"></i></Card.Title>
            <Card.Text id="card-header">Default</Card.Text>
            <Card.Text id="card-text">0.01 IAQ tokens for each sent data (max. 3)</Card.Text>
            <Card.Text id="card-text">Trial/Demo</Card.Text>
            <br/>
            <Card.Text id="card-activetext">Active : {defaultplan}</Card.Text>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-cash h3"></i></Card.Title>
            <Card.Text id="card-header"><a href="/members">Bond</a></Card.Text>
            <Card.Text id="card-text">0.10 IAQ tokens for each sent data</Card.Text>
            <Card.Text id="card-text">One time service fee of 25 USDC</Card.Text>
            <Card.Text id="card-text">All proceeds go directly to the LP</Card.Text>
            <br/>
            <Card.Text id="card-activetext">Active : {bondplan}</Card.Text>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-cash-coin h3"></i></Card.Title>
            <Card.Text id="card-header"><a href="/members">Starter</a></Card.Text>
            <Card.Text id="card-text">0.20 IAQ tokens for each sent data</Card.Text>
            <Card.Text id="card-text">One time service fee of 50 USDC</Card.Text>
            <br/>
            <Card.Text id="card-activetext">Active : {starterplan}</Card.Text>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-cash-stack h3"></i></Card.Title>
            <Card.Text id="card-header"><a target="_blank" href="https://app.tinyman.org/#/pool/ED57RDPEG53HHJKAHQGFBF74GUZ5JHH464424OZ4NSOJVV5VAL5YLZXQ5U">Premium</a></Card.Text>
            <Card.Text id="card-text">0.35 IAQ tokens for each sent data</Card.Text>
            <Card.Text id="card-text">Provide liquidity on Tinyman for IAQ/ALGO pool, minimum number of LP tokens : 5</Card.Text>
            <br/>
            <Card.Text id="card-activetext">Active : {premiumplan}</Card.Text>
          </Card.Body>
        </Card>
      </CardGroup>
      <h2 id="config_header">Staking</h2>
      <p id="reward_lead">You can stake your IAQ tokens on Cometa, the lock period is set at 30 days.</p>
      <p id="reward_lead"></p>
      <div className="bottom-line"></div>
      <CardGroup>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-bank h3"></i></Card.Title>
            <Card.Text id="card-header"><a target="_blank" href="https://app.cometa.farm/stake">IAQ token</a></Card.Text>
            <Card.Text id="card-text">200 000 IAQ in the pool for rewards.</Card.Text>
            <Card.Text id="card-text">APY will vary based on how much % of tokens you have staked.</Card.Text>
          </Card.Body>
        </Card>
        <Card className="text-center" bg="dark" style={{width: '18rem'}}>
          <Card.Body>
            <Card.Title><i className="bi bi-bank2 h3"></i></Card.Title>
            <Card.Text id="card-header"><a target="_blank" href="https://app.cometa.farm/farm">LP tokens</a></Card.Text>
            <Card.Text id="card-text">100 000 IAQ in the pool for rewards.</Card.Text>
            <Card.Text id="card-text">APY will vary based on how much % of tokens you have in the pool.</Card.Text>
          </Card.Body>
        </Card>
      </CardGroup>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </Container>
  );
}
